import React, { useState, useMemo, useEffect } from 'react'
import {
   Typography,
   Button,
   FormControl,
   InputLabel,
   Select,
   OutlinedInput,
   FormHelperText,
   MenuItem,
   IconButton,
   Grid,
   Modal,
   Paper,
   TextField
} from '@material-ui/core'
import Alert from '@material-ui/lab/Alert'
import { makeStyles } from '@material-ui/core/styles'
import TRANSLATE, { VALUES, REGEXP } from 'utils/constants'
import Utils from 'utils/utils'
import { Autocomplete } from '@material-ui/lab'
import utils from 'utils/utils'
import { useApiRequest } from 'utils/customHooks/useApiRequest'
import { getFromApi } from 'actions'

const formContainerStyle = {
   display: 'flex',
   flexDirection: 'column',
   justifyContent: 'space-between',
   alignItems: 'center',
   width: '95%',
   margin: '0 auto 10px'
}

const useStyles = makeStyles(theme => ({
   formControl: {
      width: '100%',
      textAlign: 'initial',
      fontSize: 14,
      '&:not(:first-child)': {
         marginTop: 20
      }
   },
   helperText: {
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      fontSize: 11
   },
   formControlTextArea: {
      width: '100%',
      textAlign: 'initial',
      fontSize: 14,
      '&:not(:first-child)': {
         marginTop: 20
      }
   },
   button: {
      width: '140px',
      height: 40,
      marginTop: 20,
      color: 'white',
      background: '#3264DC'
   },
   formCleanButton: {
      color: '#3264DC',
      border: '1px solid #3264DC',
      fontWeight: 'bold',
      marginTop: 20,
      width: '140px'
   },
   formContainer: formContainerStyle,
   form: {
      ...formContainerStyle,
      paddingTop: '1rem'
   },
   titleOne: {
      margin: '20px 0 15px 9px',
      fontStyle: 'normal',
      fontSize: 14,
      alignSelf: 'start',
      color: '#8A8FAB',
      fontWeight: 400
   },

   containerButtonSubmit: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%'
   },

   // dropzone
   modal: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0,0,0,.5)',
      zIndex: 10000,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
   },
   paper: {
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #cecece',
      borderRadius: '4px',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 1, 3),
      maxWidth: '550px'
   },
   confirmModalContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: '1.6rem 3rem',
      gap: '1rem',
      paddingBottom: '5rem'
   },
   iconContainer: {
      alignSelf: 'center',
      marginBottom: 16
   },
   warningIcon: {
      color: '#fe6320',
      fontSize: 68
   },

   containerIconImage: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between'
   },

   uploadImage: {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
      borderRadius: '0px',
      border: '1px solid #8A8FAB8D',
      borderRadius: '4px',
      padding: '10px',
      color: '#7a7575',
      marginTop: '10px',
      '&:hover': {
         cursor: 'pointer',
         backgroundColor: 'none',
         borderRadius: '4px'
      }
   },
   uploadImage2: {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
      borderRadius: '0px',
      border: '1px solid #f44336',
      borderRadius: '4px',
      padding: '10px',
      color: '#7a7575',
      marginTop: '10px',
      '&:hover': {
         cursor: 'pointer',
         backgroundColor: 'none',
         borderRadius: '4px'
      }
   },
   imageText: {
      color: '#7a7575'
   },

   imageText2: {
      color: '#7a7575'
   },
   errorImg: {
      color: '#f44336',
      fontSize: '11px',
      marginTop: '1px'
   },

   iconImage: {
      fontSize: 24
   },

   // modal
   modalContainer: {
      backgroundColor: '#F9FAFC',
      width: '45%',
      right: 0,
      float: 'right',
      position: 'absolute',
      borderRadius: 0
   },

   uploadIconModal: {
      backgroundColor: '#FFFFFF',
      color: '#43496A',
      width: '150px',
      height: '150px',
      marginBottom: '20px',
      '&:hover': {
         cursor: 'pointer'
      }
   },

   modalContent: {
      backgroundColor: '#F9FAFC',
      height: '100vh',
      borderRadius: 0
   },

   dropZoneAreaModal: {
      paddingTop: '45%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      textAlign: 'center'
   },

   topBoxModal: {
      position: 'absolute',
      width: '100%',
      top: '20px',
      marginRight: '20px',
      display: 'flex',
      justifyContent: 'center'
   },

   topBoxContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '95%',
      borderBottom: '1px solid #A1A4B5'
   },

   closeIcon: {
      marginRight: 10,
      marginTop: -1,
      color: '#B1B5C8',
      '& span': { color: '#3264DC', fontWeight: 600 },
      '&:hover': {
         cursor: 'pointer'
      }
   },

   spanTitleIcon: {
      display: 'block',
      color: '#43496A',
      fontWeight: '500',
      fontSize: '18px'
   },
   spanIconClick: {
      borderBottom: '1px solid #43496A',
      cursor: 'pointer'
   }
}))

const SearchQuestionnaireForm = React.memo(
   ({ Controller, resetForm, onSubmit, handleSubmit, control }) => {
      const classes = useStyles()
      const [allActiveApplications, setAllActiveApplications] = useState([])
      const [allActiveRoles, setAllActiveRoles] = useState([])

      const [allActiveGroups, setAllActiveGroups] = useState([])

      // ------------- Fetch all Initial Applications active  -----------------
      async function _getAllActiveApplications() {
         const url = `${process.env.REACT_APP_APPLICATIONS_API}/applications/active`
         const searchedAplications = await getFromApi(url)
         setAllActiveApplications(searchedAplications)
      }

      const getAllActiveApplications = useApiRequest(
         _getAllActiveApplications,
         'Aplicaciones: Consultar Aplicaciones activas'
      )
      // ------------- Fetch all role active  -----------------
      async function _getAllActiveRoles() {
         const url = `${process.env.REACT_APP_ROLE}/roles/active`
         const searchedRoles = await getFromApi(url)
         setAllActiveRoles(searchedRoles)
      }

      const getAllActiveRoles = useApiRequest(
         _getAllActiveRoles,
         'Role: Consultar roles Activos'
      )
      // ------------- Fetch all group active  -----------------
      async function _getAllActiveGroups() {
         const url = `${process.env.REACT_APP_GROUP}/groups/active`
         const searchedGroups = await getFromApi(url)
         setAllActiveGroups(searchedGroups)
      }

      const getAllActiveGroups = useApiRequest(
         _getAllActiveGroups,
         'Group: Consultar grupos Activos'
      )

      useEffect(() => {
         getAllActiveApplications()
         getAllActiveRoles()
         getAllActiveGroups()
      }, [])

      const statusMenuItems = [
         { id: 'BORRADOR', label: 'Borrador' },
         { id: 'PUBLICADO', label: 'Publicado' },
         { id: 'PROGRAMADO', label: 'Programado' },
         { id: 'INACTIVO', label: 'Inactivo' }
      ]

      return (
         <div className={classes.formContainer}>
            <Typography className={classes.titleOne}>
               <b> Completa los campos </b>{' '}
            </Typography>
            <form
               onSubmit={handleSubmit(onSubmit)}
               className={classes.form}
               encType="multipart/form-data"
            >
               <FormControl
                  variant="outlined"
                  size="small"
                  className={classes.formControl}
               >
                  <Controller
                     control={control}
                     name="name"
                     render={({ field }) => (
                        <TextField
                           {...field}
                           label="Nombre"
                           variant="outlined"
                        />
                     )}
                  />
               </FormControl>
               <FormControl
                  variant="outlined"
                  size="small"
                  className={classes.formControl}
               >
                  <Controller
                     control={control}
                     name="applicationId"
                     render={({
                        field: { value, onChange, onBlur, ref },
                        fieldState: { error }
                     }) => (
                        <Autocomplete
                           // {...field}
                           name="applicationId"
                           value={value}
                           options={allActiveApplications ?? []}
                           onChange={(_, data) => onChange(data)}
                           getOptionLabel={option =>
                              option.name
                                 ? utils.capitalizeFirstLetter(option.name)
                                 : option?.name
                           }
                           renderOption={option => (
                              <span key={option.id}>{option.name}</span>
                           )}
                           size="medium"
                           renderInput={params => (
                              <TextField
                                 {...params}
                                 // {...field}
                                 inputRef={ref}
                                 label="Seleccionar aplicación"
                                 variant="outlined"
                                 // error={errors?.subdomainId}
                                 // helperText={errors?.subdomainId ? errors.subdomainId?.message : ''}
                                 // error={invalid.subdomainId}
                              />
                           )}
                        />
                     )}
                  />
               </FormControl>
               <FormControl
                  variant="outlined"
                  size="small"
                  className={classes.formControl}
               >
                  <Controller
                     control={control}
                     name="roles"
                     render={({
                        field: { value, onChange, onBlur, ref },
                        fieldState: { error }
                     }) => (
                        <Autocomplete
                           // {...field}
                           multiple
                           name="roles"
                           value={value}
                           onChange={(_, data) => onChange(data)}
                           options={allActiveRoles ?? []}
                           getOptionLabel={option =>
                              option.name
                                 ? utils.capitalizeFirstLetter(option?.name)
                                 : option?.name
                           }
                           renderOption={option => (
                              <span key={option?.id}>{option?.name}</span>
                           )}
                           size="medium"
                           renderInput={params => (
                              <TextField
                                 {...params}
                                 inputRef={ref}
                                 label="Seleccionar rol"
                                 variant="outlined"
                              />
                           )}
                        />
                     )}
                  />
               </FormControl>
               <FormControl
                  variant="outlined"
                  size="small"
                  className={classes.formControl}
               >
                  <Controller
                     control={control}
                     name="ngroups"
                     render={({
                        field: { value, onChange, onBlur, ref },
                        fieldState: { error }
                     }) => (
                        <Autocomplete
                           // {...field}
                           multiple
                           name="ngroups"
                           value={value}
                           options={allActiveGroups ?? []}
                           onChange={(_, data) => onChange(data)}
                           getOptionLabel={option =>
                              option.name
                                 ? utils.capitalizeFirstLetter(option?.name)
                                 : option?.name
                           }
                           renderOption={option => (
                              <span key={option?.id}>{option?.name}</span>
                           )}
                           size="medium"
                           renderInput={params => (
                              <TextField
                                 {...params}
                                 label="Seleccionar grupo"
                                 variant="outlined"
                              />
                           )}
                        />
                     )}
                  />
               </FormControl>
               <FormControl
                  ariant="outlined"
                  size="small"
                  className={classes.formControl}
               >
                  <Controller
                     control={control}
                     name="status"
                     render={({
                        field: { value, onChange, onBlur, ref },
                        fieldState: { error }
                     }) => (
                        <Autocomplete
                           // {...field}
                           multiple
                           name="status"
                           value={value}
                           options={statusMenuItems ?? []}
                           onChange={(_, data) => onChange(data)}
                           getOptionLabel={option =>
                              option?.label
                                 ? utils.capitalizeFirstLetter(option?.label)
                                 : option?.label
                           }
                           renderOption={option => (
                              <span key={option?.id}>{option?.label}</span>
                           )}
                           size="medium"
                           renderInput={params => (
                              <TextField
                                 {...params}
                                 label="Seleccionar Estado"
                                 variant="outlined"
                              />
                           )}
                        />
                     )}
                  />
               </FormControl>

               <div className={classes.containerButtonSubmit}>
                  <Button
                     classes={{
                        root: classes.formCleanButton
                     }}
                     variant="outlined"
                     onClick={() => resetForm()}
                  >
                     Limpiar
                  </Button>
                  <Button
                     type="submit"
                     variant="contained"
                     color="primary"
                     classes={{
                        root: classes.button
                     }}
                     // onClick={actionSubmitEvent}
                  >
                     Consultar
                  </Button>
               </div>
            </form>
         </div>
      )
   }
)

export default SearchQuestionnaireForm
